import { render, staticRenderFns } from "./ProtoQuizGenerator.vue?vue&type=template&id=197b20da&"
import script from "./ProtoQuizGenerator.vue?vue&type=script&lang=ts&"
export * from "./ProtoQuizGenerator.vue?vue&type=script&lang=ts&"
import style0 from "./ProtoQuizGenerator.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports